export const TRIGGER_TYPE_REMINDER = "Triggerable::TaskReminderTiming" as const;

export type ReminderTriggerType = typeof TRIGGER_TYPE_REMINDER;
export type ReminderReferenceEvent = "start_at" | "due_at";
export type ReminderOffsetUnit = "day" | "week" | "month" | "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";

interface CommonTimingFields {
  referenceEvent: ReminderReferenceEvent;
  descriptor?: string;
  sortValue?: number;
}

interface EventDayTimingData extends CommonTimingFields {
  offset: 0;
  offsetUnit?: undefined;
}

interface NotEventDayTimingData extends CommonTimingFields {
  offset: number;
  offsetUnit: ReminderOffsetUnit;
}

export type ReminderTriggerData =
  | EventDayTimingData
  | NotEventDayTimingData;

export interface ReminderTrigger {
  id: string;
  type: ReminderTriggerType;
  data: ReminderTriggerData;
  createdAt: Date;
  updatedAt: Date;
}

// Local

export type LocalReminderTrigger = {
  type: ReminderTriggerType;
  data: Partial<
  Required<Pick<ReminderTriggerData, "referenceEvent" | "offsetUnit">> & {
    offsetValue: number;
    offsetDirection: "before" | "exact" | "after";
  }
  >;
};
